import './Development.scss';
import {
    ArrowUpRight,
    Boxes,
    CodeXml,
    Globe,
} from 'lucide-react';
import {Link} from 'react-router-dom';
import {useTranslation} from "react-i18next";

type Development = {
    number: string;
    href: string;
    icon: 'minecraft' | 'web';
    accent: 'green' | 'blue';
};

const developments: Development[] = [
    {
        number: '01',

        href: '/servizi/development/minecraft',
        icon: 'minecraft',
        accent: 'green',
    },
    {
        number: '02',
        href: '/servizi/development/web',
        icon: 'web',
        accent: 'blue',
    },
];

function DevelopmentIcon({type}: { type: Development['icon'] }) {
    switch (type) {
        case 'minecraft':
            return <Boxes strokeWidth={1.6}/>;

        case 'web':
            return <Globe strokeWidth={1.6}/>;
    }
}

export default function Development() {
    const { t } = useTranslation();
    return (
        <section className="developments-section" id="servizi">
            <div className="developments-orb developments-orb--left"/>
            <div className="developments-orb developments-orb--right"/>

            <div className="developments-container">

                <header className="developments-header">
                    <h2>
                        {t(`services.developer.title.normal`)}
                        <span> {t(`services.developer.title.bold`)}</span>
                    </h2>

                    <p>
                        {t(`services.developer.subtitle`)}
                    </p>
                    <div className="developments-header__eyebrow">
                        <span className="developments-header__line"/>
                        <span>{t(`services.developer.development`)}</span>
                        <span className="developments-header__line"/>
                    </div>
                </header>

                <div className="developments-grid">
                    {developments.map((development) => (
                        <Link
                            key={development.number}
                            to={development.href}
                            className={`development-card development-card--${development.accent}`}
                            aria-label={`Scopri il servizio ${t(`services.developer.card.${development.number}.title`)}`}
                        >
                            <div className="development-card__glow"/>

                            <div className="development-card__top">
                                <span className="development-card__category">
                                    {t(`services.developer.card.${development.number}.title`)}
                                </span>
                            </div>

                            <div className="development-card__main">
                                <div className="development-card__icon">
                                    <div className="development-card__icon-glow"/>

                                    <DevelopmentIcon
                                        type={development.icon}
                                    />
                                </div>

                                <div className="development-card__content">
                                    <h3 className="development-card__title">
                                        {t(`services.developer.card.${development.number}.title`)}
                                    </h3>

                                    <p className="development-card__description">
                                        {t(`services.developer.card.${development.number}.subtitle`)}
                                    </p>
                                </div>
                            </div>

                            <div className="development-card__bottom">
                                <span className="development-card__cta">
                                    {t(`services.discoverservice`)}
                                </span>

                                <span className="development-card__arrow">
                                    <ArrowUpRight strokeWidth={1.8}/>
                                </span>
                            </div>

                            <div className="development-card__shine"/>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
}
